import { render, staticRenderFns } from "./veStuXjAuditShow.vue?vue&type=template&id=2a851166&scoped=true"
import script from "./veStuXjAuditShow.vue?vue&type=script&lang=js"
export * from "./veStuXjAuditShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a851166",
  null
  
)

export default component.exports